import {Box} from '@mantine/core';
import {useRouter} from 'next/router';
import {type FC, useEffect} from 'react';
import {routes} from '../../../config/constants';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../../core/entities/login/constants';
import {destroyCookieWithLogout} from '../../../core/usecases/auth/destroyCookieWithLogout';
import {notifySessionExpirationToRNApp} from '../../../core/usecases/auth/notifySessionExpirationToRNApp';
import {redirectToLoginOnSessionExpiration} from '../../../core/usecases/auth/redirectToLoginOnTokenExpiraration';
import {useIsAppWebView} from '../../hooks/useIsAppWebView';
import {CommonLink} from '../CommonLink';
import {GeneralFooter} from '../Footer/general';
import {GeneralHeaderContainer} from '../Header/General/container';

export const SessionExpiredPage: FC<{resolvedUrl: string}> = ({
  resolvedUrl,
}) => {
  const isWebView = useIsAppWebView();
  const router = useRouter();

  useEffect(() => {
    destroyCookieWithLogout();

    if (notifySessionExpirationToRNApp()) {
      return;
    }
    setTimeout(async () => {
      await redirectToLoginOnSessionExpiration(resolvedUrl);
    }, 1500);
  }, []);

  return (
    <>
      <div>
        {!isWebView && <GeneralHeaderContainer />}
        <main>
          <Box className="flex pc:min-h-[500px] min-h-[300px] items-center justify-center bg-background-1 py-12 pc:py-32">
            <div className="bg-white-1 flex flex-col items-center justify-center p-36 w-[90%] max-w-[600px] shadow-bottom">
              <p className="text-md leading">セッションが切れました</p>
              <p className="text-md leading">再ログインをお願いします</p>
              <CommonLink
                href={`${routes.LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`}
                className="text-link text-md leading mt-12 pc:hover:opacity-80"
              >
                ログイン画面へ
              </CommonLink>
            </div>
          </Box>
        </main>
        {!isWebView && <GeneralFooter />}
      </div>
    </>
  );
};
